import type { FilterOption } from './filter-panel.type';

/**
 * Converts filter options into Mantine Combobox `data` with guaranteed string labels.
 *
 * A searchable Mantine Select/MultiSelect runs its options filter, which calls
 * `option.label.toLowerCase()` and throws — white-screening the whole panel — when a
 * label is null/undefined. `FilterOption.label` is typed `string | ReactNode`, so a
 * blank label is legal and previously reached the control through an unchecked
 * `as string` cast. Any non-string or blank label falls back to the option `value`
 * (always a usable string), so the filter can never crash; real string labels pass
 * through unchanged.
 *
 * @param {FilterOption[]} options - The filter group options to sanitize
 * @returns {{ value: string; label: string }[]} Options safe to pass to Mantine `data`
 */
const toComboboxData = (options: FilterOption[]): { value: string; label: string }[] =>
  options.map((option) => ({
    value: option.value,
    label: typeof option.label === 'string' && option.label.trim() ? option.label : option.value,
  }));

export { toComboboxData };
